var map = {
	"./alain.jpeg": 314,
	"./andras.jpeg": 4114,
	"./bg.png": 5878,
	"./budapest4.jpg": 8331,
	"./castle1.jpg": 6032,
	"./castle2.jpg": 7188,
	"./castle4.jpg": 2294,
	"./justitia.png": 7203,
	"./law2.png": 6698,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./roland.jpeg": 7339,
	"./ugk1.svg": 710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;